import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["hint"]
  static values = {
    minRemaining: { type: Number, default: 220 },
    hideAfterScroll: { type: Number, default: 120 },
    scrollStepRatio: { type: Number, default: 0.7 }
  }

  connect() {
    this.onScroll = this.onScroll.bind(this)
    this.onResize = this.onResize.bind(this)

    window.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onResize)

    this.updateHint()
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onResize)
  }

  scrollDown(event) {
    event.preventDefault()

    const step = Math.max(280, window.innerHeight * this.scrollStepRatioValue)
    window.scrollBy({ top: step, behavior: "smooth" })
  }

  onScroll() {
    this.updateHint()
  }

  onResize() {
    this.updateHint()
  }

  updateHint() {
    if (!this.hasHintTarget) return

    const remaining = document.documentElement.scrollHeight - (window.scrollY + window.innerHeight)
    const hasEnoughContent = document.documentElement.scrollHeight > window.innerHeight + this.minRemainingValue
    const userAlreadyScrolled = window.scrollY > this.hideAfterScrollValue

    const shouldShow = hasEnoughContent && remaining > this.minRemainingValue && !userAlreadyScrolled

    this.hintTarget.classList.toggle("hidden", !shouldShow)
    this.hintTarget.setAttribute("aria-hidden", (!shouldShow).toString())
  }
}
